import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { SITE_NAME, staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/tsubaki-2'

const getClientModule = () => import('src/clientRoutes/tsubaki-2')

export const handle = {
  name: 'tsubaki-2',
  track: { scene: 'model-landing', section: 'tsubaki-2' },
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: `${t('server:meta.tsubaki2.title')} | ${SITE_NAME}`,
    description: t('server:meta.tsubaki2.description'),
    image: t('server:meta.tsubaki2.image'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
